import React from "react";
import { MiniBoard, Avatar } from "components";
import { Stage } from "./_shared";

const SAMPLE_CATS = ["POP CULTURE", "DEEP SPACE", "BAD MOVIES", "WILDCARD"];

export const gameSpecificEntries = [
  {
    id: "mini-board", name: "MiniBoard", group: "Game-specific", status: "live",
    description: "Read-only Jeopardy thumbnail — Korinna categories, Helvetica Inserat values, gold-on-navy, DD tint. Theme-var-driven.",
    props: [
      { name: "categories", type: "string[]", description: "Labels (empty → emptyLabel)" },
      { name: "values", type: "number[]", default: "[200,400,600]", description: "Rows" },
      { name: "dailyDoubles", type: "[col,row][]", description: "Gold-tinted cells" },
    ],
    variants: [
      { label: "Groupardy theme", render: () => <Stage width={240}><MiniBoard categories={SAMPLE_CATS} dailyDoubles={[[2, 1]]} /></Stage> },
      { label: "Blank (unnamed)", render: () => <Stage width={240}><MiniBoard categories={["", "", "", ""]} /></Stage> },
      {
        label: "Custom theme (inline vars)",
        render: () => (
          <Stage width={240}>
            <div style={{ "--board-bg": "#1c1c1c", "--category-bg": "#b8b8b8", "--category-ink": "#1c1c1c", "--cell-bg": "linear-gradient(180deg,#3a3a3a,#1c1c1c)", "--cell-value": "#e6e6e6", "--dd-bg": "linear-gradient(180deg,#e6e6e6,#9a9a9a)", "--dd-value": "#1c1c1c" }}>
              <MiniBoard categories={["METAL", "STEEL", "IRON", "ORE"]} dailyDoubles={[[1, 1]]} />
            </div>
          </Stage>
        ),
      },
    ],
    notes: ["The interactive, slice-bound MiniGameBoard remains for the controller."],
    code: `import { MiniBoard } from "components";

<MiniBoard
  categories={["POP CULTURE", "DEEP SPACE", "BAD MOVIES", "WILDCARD"]}
  dailyDoubles={[[2, 1]]}
/>

// Per-game theme — set the theme vars on a wrapper:
<div style={{ "--cell-value": "#e6e6e6", "--category-bg": "#b8b8b8" }}>
  <MiniBoard categories={["METAL", "STEEL", "IRON", "ORE"]} />
</div>`,
  },
  {
    id: "avatar", name: "Avatar", group: "Game-specific", status: "live",
    description: "Circular initials avatar with a deterministic brand gradient from a seed string.",
    props: [
      { name: "name", type: "string", description: "Seed (initials + color)" },
      { name: "size", type: "'sm'|'md'|'lg'|number", default: "'md'", description: "Diameter" },
    ],
    variants: [
      { label: "Sizes", render: () => <Stage><div style={{ display: "flex", gap: 12, alignItems: "center" }}><Avatar name="Maya Chen" size="sm" /><Avatar name="Jordan Patel" size="md" /><Avatar name="Priya Shah" size="lg" /></div></Stage> },
      { label: "Seed colors (legible ink)", render: () => <Stage><div style={{ display: "flex", gap: 8 }}>{["Maya Chen", "Jordan Patel", "Priya Shah", "Sam Okafor", "Lee Park", "Ali Reza"].map((n) => <Avatar key={n} name={n} />)}</div></Stage> },
    ],
    code: `import { Avatar } from "components";

<Avatar name="Maya Chen" />
<Avatar name="Jordan Patel" size="lg" />
<Avatar name="Priya Shah" src="/avatars/priya.jpg" />`,
  },
];
